(function() {
  'use strict';
  
  function initMobileCards() {
    // Detección rápida
    if (window.innerWidth > 768) return;
    
    const table = document.querySelector('.rte table');
    if (!table) return;
    
    const rows = table.querySelectorAll('tr');
    if (rows.length < 2) return;
    
    // Crear contenedor
    const fragment = document.createDocumentFragment();
    const container = document.createElement('div');
    container.className = 'store-cards-container';
    
    // Procesar filas
    const days = ['Lun-Jue', 'Viernes', 'Sábado', 'Domingo'];
    
    for (let i = 1; i < rows.length; i++) {
      const cells = rows[i].querySelectorAll('td');
      if (cells.length === 0) continue;
      
      const card = document.createElement('div');
      card.className = 'store-card';
      
      // Extraer datos
      const data = {
        name: cells[0]?.textContent.trim() || '',
        phone: cells[1]?.textContent.trim() || '',
        address: cells[2]?.textContent.trim() || '',
        hours: days.map((day, j) => ({
          day,
          time: cells[j + 3]?.textContent.trim() || ''
        })).filter(h => h.time)
      };
      
      // Construir HTML
      card.innerHTML = `
        <div class="store-card-header">${data.name}</div>
        <div class="store-card-info">
          ${data.phone ? `<div class="store-info-row">
            <div class="store-info-label">TELÉFONO</div>
            <div class="store-info-value">${data.phone}</div>
          </div>` : ''}
          ${data.address ? `<div class="store-info-row">
            <div class="store-info-label">DIRECCIÓN</div>
            <div class="store-info-value">${data.address}</div>
          </div>` : ''}
          ${data.hours.length ? `<div class="store-info-row">
            <div class="store-info-label">HORARIOS</div>
            <div class="store-hours">
              ${data.hours.map(h => `<div class="store-hours-item">
                <span class="store-hours-day">${h.day}:</span>
                <span class="store-hours-time">${h.time}</span>
              </div>`).join('')}
            </div>
          </div>` : ''}
        </div>
      `;
      
      container.appendChild(card);
    }
    
    // Una sola inserción
    fragment.appendChild(container);
    table.parentNode.insertBefore(fragment, table.nextSibling);
  }
  
  // Ejecutar cuando el DOM esté listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileCards);
  } else {
    initMobileCards();
  }
})();